module.exports = __webpack_public_path__ + "img/mba.52c638ff.png";